/** Import modules */

import { useNavigate, useParams }       from "react-router-dom";

/** Import hooks */

import { RimsNavigator }                from "../../../../../Hooks/RimsNavigator";

/** Import icons */

import { FaCheck }                      from "react-icons/fa";
import { useTranslation } from "react-i18next";

/**
 * 
 * @param { attributes } param0 
 * 
 * @returns Manufacturers filter component
 * 
 */

const Radius = ( { attributes } ) => { const 

    { t }                   = useTranslation    (),

    navigate                = useNavigate       (),

    { parameters }          = useParams         (),

    params                  = new URLSearchParams ( parameters ),

    /** On manufacturer change update the query */

    loadRadiuses = event => { const 

        object = { f : 12, l : null, a : null, b : null, r : params.get ( "r" ) ? params.get ( "r" ).split ( "," ) : [], loc: window.pageYOffset };

        if ( event.target.checked ) { object.r.push ( event.target.value );

            return navigate (  
            
                `/shop/rims/${
                
                    new URLSearchParams ( RimsNavigator ( parameters, object ) ).toString () }` );
        
        } else { object.r.splice ( params.get ( "r" ).split ( "," ).indexOf ( event.target.value ), 1 );

            return navigate (  
            
                `/shop/rims/${
                
                    new URLSearchParams ( RimsNavigator ( parameters, object ) ).toString () }` );

        }

    }

    /** Return component */

    return ( <div className="content manufacturers">

        <div className="attribute-filter">

            <div className="collection-container">

                <div className="collection" id="collection">

                    { sortPrams ( attributes, params, "r" ).map ( ( radiuses, index ) => <label 
                    
                        htmlFor={ `noise_${radiuses.value}` } 
                        
                        className="checkbox" 
                        
                        key={ index }>

                        <input 

                            type="checkbox" 

                            id={ `noise_${radiuses.value}` } 

                            value={ parseInt ( radiuses.text ) } 

                            onChange={ e => loadRadiuses ( e ) } 
                            
                            checked={ params.get ( "r" ) && ( params.get ( "r" ).split ( "," ).indexOf ( parseInt ( radiuses.text ).toString () ) !== -1 ) } />

                        <span className="check">

                            <span className="checked">

                                <FaCheck />

                            </span>

                        </span>

                        <span className="name">

                            { parseInt ( radiuses.text ) }

                        </span>

                    </label> ) }

                </div>

            </div>

        </div>

    </div> );

},

/**
 * 
 * @param { attributes } param0
 * 
 * @param { params } param1
 * 
 * @param { key } param2
 * 
 * @returns sorted params
 * 
 * Sort params by checked values
 * 
 * If checked values exist, move them to the top of the list
 * 
 * If checked values don't exist, return the list as it is
 * 
 */

sortPrams = ( attributes, params, key ) => { const

    /** Get checked values */

    checkedValues = params.get ( key ) ? params.get ( key ).split ( "," ) : [],

    /** Get unchecked values */

    loadIndexes = attributes.filter ( attribute => !checkedValues.includes ( parseInt ( attribute.value ).toString () ) );

    /** If checked values exist, move them to the top of the list */

    if ( checkedValues.length ) { checkedValues.forEach ( checkedValue => { const

        index = attributes.findIndex ( attribute => parseInt ( attribute.value ) == checkedValue );

        loadIndexes.unshift ( attributes [ index ] );

    } ); }

    /** Return the list */

    return loadIndexes;

}

/** Export component */
 
export default Radius;